import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// Components
import Spinner from 'components/Spinner';
import FailureMessage from 'components/FailureMessage';
import Modal from 'components/CncUI/Modal';

import { Document, Page, pdfjs } from 'react-pdf';
// Utilities
import Logger from 'utilities/logger';
// PDF worker setup, import it as media to workaround CRA setup
const workerURL = process.env.PUBLIC_URL + '/scripts/pdf.worker.min.js';
pdfjs.GlobalWorkerOptions.workerSrc = workerURL;

const useStyles = makeStyles(() => ({
  dialog: {
    maxWidth: '90vw',
  },
  content: {
    padding: '4px !important',
  },
}));

const FileViewer = ({ fileFetcher, config, url, onClose, loaderMessage }) => {
  const logger = Logger('FileViewer');
  const classes = useStyles();
  const [state, setState] = useState({
    file: null,
    numberOfPages: 0,
    loading: true,
    error: null,
  });
  const modify = data => setState(old => ({ ...old, ...data }));

  useEffect(() => {
    if (url) {
      modify({ file: url, loading: false });
      return;
    }
    async function fetchData() {
      try {
        const file = await fileFetcher(config);
        modify({ file, loading: false });
      } catch (error) {
        const errorMessage = typeof error === 'object' ? error.message : error;
        modify({ error: errorMessage, loading: false });
        logger.error(error);
      }
    }
    fetchData();
  }, []);

  const pages = () => {
    const { numberOfPages } = state;
    if (!numberOfPages || numberOfPages === 0) return;
    const arr = [];
    for (let i = 1; i <= numberOfPages; i++) {
      arr.push(
        <Page
          pageNumber={i}
          scale={2.0}
          key={`PdfViewer-page-${i}`}
          data-test-id={`PdfViewer-Page-${i}`}
        />,
      );
    }
    return arr;
  };

  const onDocumentLoadSuccess = pdfData => {
    const { numPages: numberOfPages } = pdfData;
    modify({ numberOfPages });
  };

  const onError = err => {
    logger.error(err);
  };

  return (
    <Modal
      id="File-Viewer-Modal"
      open={true}
      onClose={onClose}
      scroll={'paper'}
      aria-label="Paystub-loader"
      data-test-id="File-Viewer-Modal"
      classes={{ paper: classes.dialog }}
    >
      <Modal.Content className={classes.content}>
        {state.loading && (
          <Spinner
            message={
              loaderMessage ||
              'Please wait a moment while we get this file from our secure storage...'
            }
          />
        )}
        {state.error && (
          <FailureMessage message={state.error} onClose={onClose} />
        )}
        {!state.loading && !state.error && (
          <Document
            file={state.file}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={
              <Spinner message={loaderMessage || 'File fetched, loading...'} />
            }
            onLoadError={onError}
            onSourceError={onError}
            error={<FailureMessage onClose={onClose} />}
            noData={<FailureMessage onClose={onClose} />}
          >
            {pages()}
          </Document>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default FileViewer;
